/**
 * The domain page's sections, as URL segments (context STORY-0266): `/domains/$domainId/$section`.
 * Kept out of `domain.tsx` so the router can check a section without loading the page's chunk.
 * Changing an id breaks every link to it — alerts, emails, the Copilot — so add, do not rename.
 */
export const DOMAIN_SECTIONS = [
  'mailboxes',
  'aliases',
  'catch-all',
  'dns',
  'dkim',
  'spam',
  'sending',
  'ai',
  'categories',
  'activity',
  'dmarc',
  'tls-reports',
] as const;
export type DomainSection = (typeof DOMAIN_SECTIONS)[number];
export const isDomainSection = (s: string): s is DomainSection =>
  (DOMAIN_SECTIONS as readonly string[]).includes(s);
